import React from 'react';
import classNames from 'classnames';
import './explore-tab-wrapper.scss';

const ExploreTabWrapper = props => (
  <div
    className={classNames('explore-tab', props.style, { current: props.isCurrentTab })}
    role="tabpanel"
    onClick={props.onClickTab}>
    <div className="text-wrapper">{props.children}</div>
  </div>
);

ExploreTabWrapper.propTypes = {
  children: React.PropTypes.oneOfType([React.PropTypes.element, React.PropTypes.arrayOf(React.PropTypes.element)]),
  isCurrentTab: React.PropTypes.bool,
  style: React.PropTypes.string,
  onClickTab: React.PropTypes.func,
};

export default ExploreTabWrapper;
